module.exports = __webpack_public_path__ + "img/xs-min-cover-footer.89c90205.jpg";